import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../../core/i18n/hooks/use-language';
import { useAnonymousFormQuery } from '../hooks/use-anonymous-form-query';
import { useAnonymousSendFormRequest } from '../hooks/use-anonymous-send-form-request';
import { AnonymousFormType } from '../types';
import { usePathBuilder } from '../../../core/routing/hooks/use-path-builder';
import { FormLayout } from './form-layout';

type Props = {
  formType: AnonymousFormType;
  documentTitle: string;
  permissionToContact?: boolean;
};

export const AnonymousForm: React.FC<Props> = ({ formType, documentTitle, permissionToContact }) => {
  const { t } = useTranslation();
  const { homePath } = usePathBuilder();
  const currentLanguage = useLanguage();

  const { data: fields, isLoading: isLoadingFields } = useAnonymousFormQuery(formType);
  const { mutateAsync: sendFormRequest, isPending: isPendingFormRequest } =
    useAnonymousSendFormRequest(currentLanguage);

  return (
    <FormLayout
      documentTitle={documentTitle}
      fields={fields?.data.fields ?? []}
      formType={formType}
      isLoadingFields={isLoadingFields}
      isPendingFormRequest={isPendingFormRequest}
      linkBackTo={{ to: homePath(), label: t('global.backToHome') }}
      permissionToContact={permissionToContact}
      sendFormRequest={sendFormRequest}
    />
  );
};
